import { useEffect, useState } from "react";

/**
 * Height of everything above `.main-content` inside `.main-page-home-dashboard`
 * (promo banners, global Header, etc.). Use as `top` for nested sticky bars so they
 * sit below the app header instead of overlapping at 0.
 */
const measureLayoutTopOffset = () => {
  const root = document.querySelector(".main-page-home-dashboard");
  const mainContent = root?.querySelector(".main-content");
  if (!root || !mainContent) {
    const header = document.querySelector(".q_header_section");
    return Math.round(header?.offsetHeight ?? 0);
  }

  let offset = 0;
  for (let child = root.firstElementChild; child; child = child.nextElementSibling) {
    if (child === mainContent || child.contains(mainContent)) break;
    offset += child.offsetHeight;
  }
  return Math.round(offset);
};

const useStickyBelowLayoutHeader = () => {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const update = () => setOffset(measureLayoutTopOffset());
    update();

    const root = document.querySelector(".main-page-home-dashboard");
    if (!root) return undefined;

    const mainContent = root.querySelector(".main-content");
    const observer = new ResizeObserver(update);

    for (let child = root.firstElementChild; child; child = child.nextElementSibling) {
      if (child === mainContent || child.contains(mainContent)) break;
      observer.observe(child);
    }

    window.addEventListener("resize", update, { passive: true });
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", update);
    };
  }, []);

  return offset;
};

export default useStickyBelowLayoutHeader;
